module.exports = __webpack_public_path__ + "static/img/start3.16461f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start3.png
// module id = /NG8
// module chunks = 1